import React from 'react';

/**
 * OfflineIndicator — a small visual cue rendered next to entities that were
 * created or edited offline and have not yet synced with the server.
 *
 * The `_offline: true` flag is stamped onto entities by the offline write
 * interceptor (`utils/offlineWriteQueue.js`) when it synthesises a response.
 * The next fresh fetch from the server clears the flag automatically.
 *
 * Render is intentionally compact (an amber pulsing dot + tooltip) so it
 * communicates "syncing" without distracting from the entity itself.
 */
const OfflineIndicator = ({ entity, className = '' }) => {
  if (!entity || !entity._offline) return null;
  return (
    <span
      data-testid="offline-indicator"
      title="Saved offline — will sync when you're back online"
      aria-label="Pending sync"
      className={`inline-flex items-center justify-center w-2.5 h-2.5 ${className}`}
    >
      <span className="absolute w-2.5 h-2.5 rounded-full bg-amber-400 opacity-75 animate-ping" />
      <span className="relative w-2 h-2 rounded-full bg-amber-500 ring-2 ring-amber-100" />
    </span>
  );
};

export default OfflineIndicator;
